export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["DEV"] = "dev";
})(UserRole || (UserRole = {}));
